import { render, staticRenderFns } from "./FormaPagamentoList.vue?vue&type=template&id=5b0a73d4"
import script from "./FormaPagamentoList.vue?vue&type=script&lang=js"
export * from "./FormaPagamentoList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports